import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function

async function createNewMaster(
  uid,
  entreprise,
  adresse,
  phone,
  ville,
  postal,
  fullname,
  siret,

  prefix,
  token
) {
  // Define the endpoint URL
  const url = prefix + "organisations/master";

  // Define the request body
  const body = {
    uid: uid,
    entreprise: entreprise,
    adresse: adresse,

    phone: phone,
    ville: ville,
    postal: postal,
    fullname: fullname,
    siret: siret,
  };

  // Define headers, including authorization token
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    // Get the current user
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return null;
    }

    // Get Firestore instance
    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return null;
    }

    const org_id = userSnapshot.get("org_id");
    const responseText = await response.text();

    // Log the request and response using addLogDocument
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // Additional fields if necessary
      "",
      JSON.stringify(body), // Request body as a string
      responseText,
      "POST"
    );

    // Check if the request was successful
    if (response.ok) {
      // Return the Firestore document reference for the created master
    } else {
      console.error(`Error: ${response.status}`);
      return null;
    }
  } catch (error) {
    // Handle exceptions
    console.error("Error:", error);
    return null;
  }
}

export default createNewMaster;
